import {CgSpinnerTwoAlt} from 'react-icons/cg'
import './Spinner.css'
export default function Spinner() {
  return(
    <div className='spinner'>
      <CgSpinnerTwoAlt className='animate-spin mx-auto' size={50}/>
    </div>
  )
}